import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HOME_PAGE } from '../constants/routes';
import { TOKEN_DATA_KEY } from '../constants/login';

function PrivateRoute({ children, type, redirectRoute }) {
  const { token: reduxToken } = useSelector((store) => store.defaultReducer);
  const localStorageToken = localStorage.getItem(TOKEN_DATA_KEY);
  const location = useLocation();
  
  // Use Redux token as primary source, fallback to localStorage
  // This prevents redirects when Redux state is temporarily empty during updates
  const token = reduxToken || localStorageToken;
  
  if (!token) {
    return <Navigate to={redirectRoute ?? HOME_PAGE} replace state={{ from: location }} />;
  }
  
  return type ? React.cloneElement(children, { type }) : children;
}

export default PrivateRoute;
